import { MaterialProductValueType, SiteMaterialDetail, SiteMaterialList } from 'api';
import { UseFormSetValue } from 'form';

import { convertMaterialProductComponentAPIToMaterialComponentField } from '../../../material-products/utils/convertMaterialProductComponentAPIToMaterialComponentField/convertMaterialProductComponentAPIToMaterialComponentField';
import { BasePurchaseOrderFormValues } from '../../types';

export const updateMaterialProperties = (
  siteMaterialDetail: SiteMaterialDetail | SiteMaterialList,
  setValue: UseFormSetValue<BasePurchaseOrderFormValues>
) => {
  if (siteMaterialDetail?.material_product?.material_spec?.id) {
    setValue('material_spec_id', siteMaterialDetail?.material_product?.material_spec.id);
    setValue('material_id', siteMaterialDetail?.material_product?.material_spec.material.id);
    setValue('material_colour_id', siteMaterialDetail?.material_product?.material_spec.colour?.id);
  } else {
    setValue('material_id', siteMaterialDetail?.material_spec?.material?.id);
    setValue('material_colour_id', siteMaterialDetail?.material_spec?.colour?.id);
  }
  if (siteMaterialDetail?.material_product?.material_grade?.id) {
    setValue('grade_id', siteMaterialDetail?.material_product?.material_grade.id);
  }
  setValue('origin_id', siteMaterialDetail?.material_product?.material_origin?.id);
  setValue('production_site_id', siteMaterialDetail?.site.id);
  if (siteMaterialDetail?.material_product?.is_food_grade !== null) {
    setValue('is_food_grade', siteMaterialDetail?.material_product?.is_food_grade);
  } else {
    setValue('is_food_grade', undefined);
  }

  if (siteMaterialDetail?.material_product?.has_caps_and_labels !== null) {
    setValue('has_caps_and_labels', siteMaterialDetail?.material_product?.has_caps_and_labels);
  } else {
    setValue('has_caps_and_labels', undefined);
  }

  if (siteMaterialDetail?.material_product?.material_component_values) {
    const sellerMaterialComponentValues = convertMaterialProductComponentAPIToMaterialComponentField(
      siteMaterialDetail.material_product?.material_component_values,
      MaterialProductValueType.SELLER
    );
    setValue('seller_material_component_values', sellerMaterialComponentValues);
  } else {
    setValue('seller_material_component_values', []);
  }
};
